export default "__VITE_ASSET__4f3fd00a__"